import {
    brugereMenuLink,
    dashboardMenuLink,
    evalueringsstatistikMenuLink,
    forloebOverviewMenuLink, kursusoversigtMenu
} from "core/layout/shared/MenuLinkProps";
import {DynamicMenu} from "../DynamicMenu";
import MenuProps from "./menuProps";
import config from "../../../../config/config";


export function LedelseMenu({ showNotification, nyhederMenuLink }: MenuProps) {
    const showDashboard = config.showDashboard ?? false;
    const dashboardMenu = dashboardMenuLink();

    const menuLinks = [
        forloebOverviewMenuLink,
        brugereMenuLink,
        evalueringsstatistikMenuLink,
        nyhederMenuLink
    ];

    if (showDashboard)
        menuLinks.unshift(dashboardMenu);

    return (
        <DynamicMenu menuLinks={menuLinks} showNotifications={showNotification}/>
    );

}
